<template>
  <div class="nt-accordion">
    <!-- Items -->
    <div class="nt-accordion__item"
        :class="{ 'nt-accordion__item--active' : opened }"
      >
      <div class="nt-accordion-btn" @click="onClick">
         <slot name="button-items"></slot>
        <svg>
          <use xlink:href="#icon-arrow-down"/>
        </svg>
      </div>
      <div class="nt-accordion-items">
        <slot name="list-items" :items="items"></slot>
        <!-- More Items -->
        <div v-if="hasMore" class="nt-accordion__item"
            :class="{ 'nt-accordion__item--active' : showAll }"
          >
          <div class="nt-accordion-btn nt-accordion-btn--showall">
            <div @click="onClickToShowAll">
              <span :class="[ 'more', { 'more--active' : showAll } ]"></span>
              <span> {{ viewType }} </span>
            </div>
          </div>
        </div>
        <!-- End More Items -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nt-accordion',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Array,
      default: null
    },
    show: {
      type: Number,
      default: 10
    },
    moreText: {
      type: String,
      default: 'View More'
    },
    lessText: {
      type: String,
      default: 'View Less'
    }
  },
  data() {
    return {
      opened: this.isOpen,
      showAll: false
    }
  },
  computed: {
    hasMore() {
      return this.dataSource && this.dataSource.length > this.show
    },
    viewType() {
      return this.showAll ? this.lessText : this.moreText
    },
    items() {
      if (this.showAll) {
        return this.dataSource
      }
      return this.dataSource ? this.dataSource.slice(0, this.show) : this.dataSource
    }
  },
  mounted() {
    if (!this.isOpen) {
      this.opened = this.dataSource.some(i => i.Selected)
    }
  },
  methods: {
    onClick() {
      this.opened = !this.opened

      if (!this.opened) {
        this.showAll = false
      }
    },
    onClickToShowAll() {
      this.pushGTM()
      this.showAll = !this.showAll
    },
    pushGTM() {
      window.dataLayer.push({
        event: 'click',
        section: 'hub',
        label: this.viewType
      })
    }
  }
}
</script>
